import { render, staticRenderFns } from "./mappingList.vue?vue&type=template&id=eb8c538e&scoped=true"
import script from "./mappingList.vue?vue&type=script&lang=js"
export * from "./mappingList.vue?vue&type=script&lang=js"
import style0 from "./mappingList.vue?vue&type=style&index=0&id=eb8c538e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c538e",
  null
  
)

export default component.exports